import { AxiosError } from 'axios';
import { StripePricesLookupKeys } from 'shared';

import { baseRequest } from '../../common/lib/axiosBaseQuery';
import { env } from '../../common/lib/env';

export async function createCheckout(lookupKey: StripePricesLookupKeys, subscriptionId: string, currency: string, changePlan?: boolean) {
  try {
    return await baseRequest.post<{ url: string }>(`payments/create-checkout-session`, {
      lookupKey,
      subscriptionId,
      changePlan,
      currency,
    });
  }
  catch (error: unknown) {
    const err = error as AxiosError<{
      message?: string;
    } | string>;

    if (err.response?.status === 401) {
      // REDIRECT TO LOGIN
      window.location.href = `${env.apiUrl}/login?redirect=${window.location.href}`;

      throw new Error(`Not logged in!`);
    }

    const responseData = err.response?.data;

    if (typeof responseData === `string`) {
      throw new Error(responseData);
    }

    if (responseData?.message) {
      throw new Error(responseData.message);
    }

    throw new Error(err.message);
  }
}
